"use client";
import { useEffect, useRef, useState } from "react";
import TrackTab from "../components/trackTab";
import "./mobile.scss";
import { useLanguage } from "@/app/utils/LanguageContext";
import Footer from "../footer";
import Header from "../header";
import HeaderNav from "../headernav";
import { getAssetPrefix, STDirections, HVDirections, formatDateTime, theme } from "../utils/Common";
import { useMediaQuery } from "@mui/material";
import { useSearchParams } from "next/navigation";
const HomePageM: React.FC<any> = (props: any) => {
  const searchParams = useSearchParams();
  const onlyData = searchParams.get("onlyData") || "false";
  const { state: lang } = useLanguage();
  const { t, langCode } = lang;
  const [shouldStop, setShouldStop] = useState(true);
  const iconRef = useRef<any>(null);
  const [currentTab, setCurrentTab] = useState("");
  const { stData, hvData, stGoingData, hvGoingData, refresh, defaultTab } = props;
  const assetPrefix = getAssetPrefix();
  const isDwon375 = useMediaQuery(theme.breakpoints.down("sm")) ?? false;

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentTab(sessionStorage.getItem("currentTab") ?? defaultTab);
    }
  }, [defaultTab]);
  const handleChangeTab = (type: any) => {
    if (typeof window !== "undefined") {
      sessionStorage.setItem("currentTab", type);
    }
    setCurrentTab(type);
  };
  const handleRefresh = () => {
    refresh();
    setShouldStop(!shouldStop);
    const timer = setTimeout(() => {
      setShouldStop(true);
    }, 1000);

    return () => clearTimeout(timer);
  };
  const getWindCorlor = (speed: any) => {
    let result = `${assetPrefix}/windImg/Green.svg`;
    if (speed >= 0 && speed <= 12) {
      result = `${assetPrefix}/windImg/Green.svg`;
    } else if (speed >= 13 && speed <= 30) {
      result = `${assetPrefix}/windImg/Light Blue.svg`;
    } else if (speed >= 31 && speed <= 40) {
      result = `${assetPrefix}/windImg/Blue.svg`;
    } else if (speed >= 41 && speed <= 62) {
      result = `${assetPrefix}/windImg/Yellow.svg`;
    } else if (speed >= 63) {
      result = `${assetPrefix}/windImg/Red.svg`;
    }
    return result;
  };
  const findPriorityItem = (data: any): any => {
    const highPriorityStatuses = new Set(["DECLARED", "NAMED", "DRAFT"]);
    const lowPriorityStatuses = new Set(["RESULT", "CLOSED", "VOIDED", "ABANDONED"]);
    const namedData = data?.find((item: any) => item.status === "NAMED");
    if (namedData) {
      return namedData;
    }
    const highPriorityItems = data?.filter((item: any) => highPriorityStatuses.has(item.status));

    if (highPriorityItems?.length > 0) {
      return highPriorityItems?.reduce((minItem: any, currentItem: any) => (currentItem.no < minItem.no ? currentItem : minItem));
    }

    const lowPriorityItems = data?.filter((item: any) => lowPriorityStatuses?.has(item.status));

    if (lowPriorityItems?.length > 0) {
      return lowPriorityItems?.reduce((maxItem: any, currentItem: any) => (currentItem.no > maxItem.no ? currentItem : maxItem));
    }

    return null;
  };
  const getGoing = (data: any, type: any) => {
    let result = "--";
    const races = data?.races;
    const turfList = races?.filter((race: any) => race?.raceTrack?.code === "TURF");
    const awtList = races?.filter((race: any) => race?.raceTrack?.code === "AWT");
    const turnItem = findPriorityItem(turfList);
    const awtItem = findPriorityItem(awtList);
    if (type === "TURF") {
      if (turnItem?.status === "ABANDONED") {
        result = "--";
      } else {
        result = langCode === "en-us" ? turnItem?.go_en : turnItem?.go_ch;
      }
    } else {
      if (awtItem?.status === "ABANDONED") {
        result = "--";
      } else {
        result = langCode === "en-us" ? awtItem?.go_en : awtItem?.go_ch;
      }
    }
    return !result ? "--" : result;
  };
  const renderTurfAwt = (data: any) => {
    return (
      <div className="m_longCard" style={{ paddingBottom: "8px" }}>
        {data?.meetingTrack_en === "MIXED" ? (
          <div className="m_longCardItem">
            <div style={{ backgroundColor: "rgba(12, 178, 79, 1)" }} className="m_title">
              {langCode === "en-us" ? "TURF" : "草地"}
            </div>
            <p>
              {t("w_going")} <span>{getGoing(data, "TURF")}</span>
            </p>
            <p style={{ marginBottom: "2px" }}>{t("w_pr")}</p>
            <p className="m_large_font">{data?.penetrometerReadings?.[0]?.reading ?? "--"}</p>
            <p style={{ marginTop: "0px", lineHeight:"14px" }} className="m_small_font m_dark_font">
              {data?.penetrometerReadings?.[0]?.readingTime
                ? `${langCode === "en-us" ? "As of" : "截至"} ${formatDateTime(data?.penetrometerReadings?.[0]?.readingTime)}`
                : t("avalibleOnRace")}
            </p>
          </div>
        ) : currentTab === "HV" || data?.meetingTrack_en === "TURF" ? (
          <div className="m_longCardSingleItem">
            <div style={{ backgroundColor: "rgba(12, 178, 79, 1)" }} className="m_title">
              {langCode === "en-us" ? "TURF" : "草地"}
            </div>
            <div className="m_singleWrapper">
              <p className="m_singleLeft">
                {t("w_going")} <span>{getGoing(data, "TURF")}</span>
              </p>
              <div className="m_singleRight m_rightItem">
                <p className="textHeight_18" style={{ marginBottom: "2px" }}>{t("w_pr")}</p>
                <p className="m_large_font">{data?.penetrometerReadings?.[0]?.reading ?? "--"}</p>
                <p style={{ marginTop: "0px", lineHeight:"14px" }} className="m_read_time m_small_font m_dark_font">
                  {data?.penetrometerReadings?.[0]?.readingTime
                    ? `${langCode === "en-us" ? "As of" : "截至"} ${formatDateTime(data?.penetrometerReadings?.[0]?.readingTime)}`
                    : t("avalibleOnRace")}
                </p>
              </div>
            </div>
          </div>
        ) : null}
        {data?.meetingTrack_en === "MIXED" ? (
          <div className="m_longCardItem m_rightItem">
            <div
              style={{
                width: langCode === "en-us" ? "52px" : "80px",
                backgroundColor: "rgba(195, 107, 36, 1)",
              }}
              className="m_title"
            >
              {langCode === "en-us" ? "AWT" : "全天候跑道"}
            </div>
            <p>
              {t("w_going")} <span>{getGoing(data, "AWT")}</span>
            </p>
            <p style={{ marginBottom: "2px" }}>{t("w_chr")}</p>
            <span style={{ marginTop: "2px !important" }} className="m_large_font">
              {data?.hammerReadings?.[0]?.reading ?? "--"}
            </span>
            <p style={{ marginTop: "0px", lineHeight:"14px" }} className="m_small_font m_dark_font">
              {data?.hammerReadings?.[0]?.readingTime
                ? ` ${langCode === "en-us" ? "As of" : "截至"} ${formatDateTime(data?.hammerReadings?.[0]?.readingTime)}`
                : t("avalibleOnRace")}
            </p>
          </div>
        ) : currentTab === "ST" && data?.meetingTrack_en === "ALL WEATHER TRACK" ? (
          <div className="m_longCardSingleItem">
            <div
              style={{
                width: langCode === "en-us" ? "52px" : "80px",
                backgroundColor: "rgba(195, 107, 36, 1)",
              }}
              className="m_title"
            >
              {langCode === "en-us" ? "AWT" : "全天候跑道"}
            </div>
            <div className="m_singleWrapper">
              <p className="m_singleLeft">
                {t("w_going")} <span>{getGoing(data, "AWT")}</span>
              </p>
              <div className="m_singleRight m_rightItem">
                <p style={{ marginBottom: "2px" }}>{t("w_chr")}</p>
                <p className="m_large_font">{data?.hammerReadings?.[0]?.reading ?? "--"}</p>
                <p style={{ marginTop: "0px", lineHeight:"14px" }} className="m_read_time m_small_font m_dark_font">
                  {data?.hammerReadings?.[0]?.readingTime
                    ? `${langCode === "en-us" ? "As of" : "截至"} ${formatDateTime(data?.hammerReadings?.[0]?.readingTime)}`
                    : t("avalibleOnRace")}
                </p>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  };
  const renderEmptyTurfAwt = () => {
    return currentTab === "ST" ? (
      <div className="m_longCard" style={{ paddingBottom: "8px" }}>
        <div className="m_longCardItem">
          <div style={{ backgroundColor: "rgba(12, 178, 79, 1)" }} className="m_title">
            {langCode === "en-us" ? "TURF" : "草地"}
          </div>
          <p>
            {t("w_going")} <span>--</span>
          </p>
          <p style={{ marginBottom: "2px" }}>{t("w_pr")}</p>
          <p className="m_large_font">--</p>
          <p style={{ marginTop: "0px", lineHeight:"14px" }} className="m_read_time m_small_font m_dark_font">
            {t("avalibleOnRace")}
          </p>
        </div>
        <div className="m_longCardItem m_rightItem">
          <div
            style={{
              width: langCode === "en-us" ? "52px" : "80px",
              backgroundColor: "rgba(195, 107, 36, 1)",
            }}
            className="m_title"
          >
            {langCode === "en-us" ? "AWT" : "全天候跑道"}
          </div>
          <p>
            {t("w_going")} <span>--</span>
          </p>
          <p style={{ marginBottom: "2px" }}>{t("w_chr")}</p>
          <p style={{ marginTop: "2px !important" }} className="m_large_font">
            --
          </p>
          <p style={{ marginTop: "0px", lineHeight:"14px" }} className="m_read_time m_small_font m_dark_font">
            {t("avalibleOnRace")}
          </p>
        </div>
      </div>
    ) : (
      <div className="m_longCard" style={{ paddingBottom: "8px" }}>
        <div className="m_longCardSingleItem">
          <div style={{ backgroundColor: "rgba(12, 178, 79, 1)" }} className="m_title">
            {langCode === "en-us" ? "TURF" : "草地"}
          </div>
          <div className="m_singleWrapper">
            <p className="m_singleLeft">
              {t("w_going")} <span>--</span>
            </p>
            <div className="m_singleRight m_rightItem">
              <p style={{ marginBottom: "2px" }}>{t("w_pr")}</p>
              <p className="m_large_font">--</p>
              <p style={{ marginTop: "0px", lineHeight:"14px" }} className="m_read_time m_small_font m_dark_font">
                {t("avalibleOnRace")}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const renderBottom = (data: any) => {
    return (
      <>
        <div className="m_shortCardContainer">
          <div className="m_shortCard">
            <div className="m_shortCardWrapper">
              <p className="m_normal_font textHeight_18">{t("w_temp")}</p>
              <div className="m_valueWrapper">
                <p className="m_large_font">
                  {data[0]?.weatherStation.temperature ? data[0]?.weatherStation.temperature : "--"}
                  {data[0]?.weatherStation.temperature ? <span className="m_small_font m_unit">°C</span> : null}
                </p>
              </div>
            </div>
            <img src={`${assetPrefix}/windImg/temp.svg`} />
          </div>
          <div className="m_shortCard">
            <div className="m_shortCardWrapper">
              <p className="m_normal_font textHeight_18">{t("w_humidity")}</p>
              <div className="m_valueWrapper">
                <p className="m_large_font">
                  {data[0]?.weatherStation.relativeHumidity ? data[0]?.weatherStation.relativeHumidity : "--"}
                  {data[0]?.weatherStation.relativeHumidity ? <span className="m_small_font m_unit">%</span> : null}
                </p>
              </div>
            </div>
            <img src={`${assetPrefix}/windImg/humidity.svg`} />
          </div>
        </div>
        <div style={{}} className="m_longCard">
          <div className="m_titleItem">
            <p className="m_longTitle">{t("w_rainfall")}</p>
            <div className="m_valueItem">
              <p className="m_normal_font textHeight_18">{t("w_total")}</p>
              <p className="m_large_font">
                {data[0]?.weatherStation.rainPrecipitationDailyTotal || data[0]?.weatherStation.rainPrecipitationDailyTotal === 0 ? (
                  <>
                    {data[0]?.weatherStation.rainPrecipitationDailyTotal}
                    <span className="m_small_font m_unit">{t("w_mm")}</span>
                  </>
                ) : (
                  "--"
                )}
              </p>
              <p className="m_small_font m_dark_font" style={{lineHeight:"14px"}}>{t("w_since")}</p>
            </div>
          </div>
          <div className="m_pastItem">
            <div className="m_pastItemWrapper">
              <p className="m_normal_font textHeight_18">{t("w_forPast10min")}</p>
              <div className="m_valueWrapper">
                <p className="m_large_font">
                  {data[0]?.weatherStation.rainFallPrecipitation10Min || data[0]?.weatherStation.rainFallPrecipitation10Min === 0 ? (
                    <>
                      {data[0]?.weatherStation.rainFallPrecipitation10Min}
                      <span className="m_small_font m_unit">{t("w_mm")}</span>
                    </>
                  ) : (
                    "--"
                  )}
                </p>
              </div>
            </div>
            <img src={`${assetPrefix}/windImg/rain.svg`} />
          </div>
        </div>
        <div className="m_shortCardContainer">
          <div className="m_shortCard">
            <div className="m_shortCardWrapper">
              <p className="m_normal_font textHeight_18">{t("w_soil")}</p>
              <div className="m_valueWrapper">
                <p className="m_large_font">
                  {data[0]?.weatherStation.soilVolumeticWaterContent ? data[0]?.weatherStation.soilVolumeticWaterContent : "--"}
                  {data[0]?.weatherStation.soilVolumeticWaterContent ? <span className="m_small_font m_unit">%</span> : null}
                </p>
              </div>
            </div>
            <img src={`${assetPrefix}/windImg/soil.svg`} />
          </div>
          <div className="m_shortCard">
            <div className="m_shortCardWrapper">
              <p className="m_normal_font textHeight_18">{t("w_evapotranspiration")}</p>
              <div className="m_valueWrapper">
                <p className="m_large_font">
                  {data[0]?.weatherStation.soilMoistureLossDailyTotal || data[0]?.weatherStation.soilMoistureLossDailyTotal === 0 ? (
                    <>
                      {data[0]?.weatherStation.soilMoistureLossDailyTotal}
                      <span className="m_small_font m_unit">{t("w_mm")}</span>
                    </>
                  ) : (
                    "--"
                  )}
                </p>
                <p className="m_small_font m_dark_font" style={{lineHeight:"14px"}}>{t("w_since")}</p>
              </div>
            </div>
            <img src={`${assetPrefix}/windImg/evapotranspiration.svg`} />
          </div>
        </div>
      </>
    );
  };

  const getUpdateTime = () => {
    let result = "--";

    const weatherStation =
      currentTab === "ST"
        ? stData[0]?.weatherStation
        : hvData[0]?.weatherStation;

    if (weatherStation?.date && weatherStation?.time) {
      const [year, month, day] = weatherStation.date.split("-");
      const [hourStr, minute] = weatherStation.time.split(":");

      const hour = Number(hourStr);
      const period = hour >= 12 ? "pm" : "am";
      const hour12 = hour % 12 || 12;

      result = `${day}/${month}/${year} ${String(hour12).padStart(2, "0")}:${minute} ${period}`;
    }

    return result;
  };

  const getTitle = (data: any) => {
    if ((!data?.totalNumberOfRace && !data?.venueCode) || data?.status === "ABANDON") return;
    let result = "";
    let raceType = "";
    if (data) {
      switch (data.meetingType) {
        case "D":
          raceType = langCode === "en-us" ? "Day Race" : "日賽";
          break;
        case "N":
          raceType = langCode === "en-us" ? "Night Race" : "夜賽";
          break;
        case "T":
          raceType = langCode === "en-us" ? "Twilight Race" : "黄昏賽";
          break;
        case "E":
          raceType = langCode === "en-us" ? "Evening Race" : "黄昏賽";
          break;
      }
      result =
        langCode === "en-us"
          ? `${raceType} ${data.totalNumberOfRace ?? "--"} Races, ${
              data.venueCode === "ST" ? "Sha Tin" : "Happy Valley"
            }, ${data.meetingTrack_en ?? "--"}${data.course?.english ? ", "+data.course?.english : ""}`
          : `${raceType} ${data.totalNumberOfRace ?? "--"}場賽事, ${data.venueCode === "ST" ? "沙田" : "跑馬地"}, ${data.meetingTrack_ch ?? "--"}${data.course?.chinese ? ", "+data.course?.chinese :""}`;
    }
    return result;
  };
  const getDate = (date: any, type: any) => {
    let result = "";
    if (date) {
      if (type === "meeting") {
        let dayIndex = new Date(date).getDay();
        const weekAbbrEn = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
        const weekAbbrZh = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        const year = date?.split("-")[0];
        const month = date?.split("-")[1];
        const day = date?.split("-")[2];
        const week = langCode === "en-us" ? weekAbbrEn[dayIndex] : weekAbbrZh[dayIndex];
        result = `${day}/${month}/${year} (${week})`;
      } else {
      }
    }
    return result;
  };
  return (
    <>
      {onlyData === "true" ? null : (
        <>
          <Header />
          <HeaderNav />
        </>
      )}
      <div
        style={{
          fontFamily: langCode === "en-us" ? "Noto Sans" : "Noto Sans HK, Noto Sans",
        }}
        className="m_Container"
      >
        {onlyData === "true" ? null : (
          <div className="m_navTitle">
            <p>{t("w_weather_condition")}</p>
          </div>
        )}
        <div className="m_tabContainer">
          <TrackTab type="mobile" onTabChange={handleChangeTab} curTab={currentTab} />
          <div className="m_basicInfoWrapper">
            <p>{currentTab === "ST" ? getDate(stGoingData?.date, "meeting") : getDate(hvGoingData?.date, "meeting")}</p>
            <p>{currentTab === "ST" ? getTitle(stGoingData) : getTitle(hvGoingData)}</p>
          </div>
        </div>
        <div className="m_updateWrapper">
          <p>
            {t("w_lastUpdate")} {getUpdateTime()}
          </p>
          <img ref={iconRef} className="refresh-btn" aria-label="refresh" onClick={() => handleRefresh()} src={`${assetPrefix}/windImg/refresh.svg`} />
        </div>
        <div className="m_windTrackerContainer">
          <div className="m_windTrackerWrapper">
            <div className="windTitle">
              <h1>{t("w_windTracker")}</h1>
              <p>{t("w_windInfo")}</p>
            </div>
            <div className={currentTab === "ST" ? "m_track_show" : "m_track_hidden"}>
              <img className="compass" src={`${assetPrefix}/windImg/Compass-normal.svg`} />
              <div className="m_windTrackMapWrapper">
                <div
                  style={{
                    background: isDwon375
                      ? `url("${assetPrefix}/windImg/ST Mobile_track320px.svg") no-repeat center center`
                      : `url("${assetPrefix}/windImg/track_st_m.svg") no-repeat center center`,
                  }}
                  className="track"
                >
                  <div className="st_position1">
                    <div className="windValueItem">
                      <div className="m_wind1">
                        <img
                          style={{
                            transform: `rotate(${STDirections(stData[0]?.sectional[0]?.avgWindDirection)}deg)`,
                          }}
                          src={getWindCorlor(stData[0]?.sectional[0]?.avgWindSpeed)}
                        />
                        <div className="windValue">
                          <p className="m_bold700_font m_normal_font">{stData[0]?.sectional[0]?.avgWindDirection ? t(`w_${stData[0]?.sectional[0]?.avgWindDirection}`) : "--"}</p>
                          <p className="m_bold500_font m_normal_font">{stData[0]?.sectional[0]?.avgWindSpeed ? `${stData[0]?.sectional[0]?.avgWindSpeed} ${t("w_kmh")}` : "--"}</p>
                        </div>
                      </div>
                      <div className="m_wind2">
                        <img src={`${assetPrefix}/windImg/windIcon.svg`} />
                        <p className="m_bold500_font m_normal_font">{stData[0]?.sectional[0]?.gustWindSpeed ? `${stData[0]?.sectional[0]?.gustWindSpeed} ${t("w_kmh")}` : "--"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="st_position2">
                    <div className="windValueItem">
                      <div className="m_wind1">
                        <img
                          style={{
                            transform: `rotate(${STDirections(stData[0]?.sectional[1]?.avgWindDirection)}deg)`,
                          }}
                          src={getWindCorlor(stData[0]?.sectional[1]?.avgWindSpeed)}
                        />
                        <div className="windValue">
                          <p className="m_bold700_font m_normal_font">{stData[0]?.sectional[1]?.avgWindDirection ? t(`w_${stData[0]?.sectional[1]?.avgWindDirection}`) : "--"}</p>
                          <p className="m_bold500_font m_normal_font">{stData[0]?.sectional[1]?.avgWindSpeed ? `${stData[0]?.sectional[1]?.avgWindSpeed} ${t("w_kmh")}` : "--"}</p>
                        </div>
                      </div>
                      <div className="m_wind2">
                        <img src={`${assetPrefix}/windImg/windIcon.svg`} />
                        <p className="m_bold500_font m_normal_font">{stData[0]?.sectional[1]?.gustWindSpeed ? `${stData[0]?.sectional[1]?.gustWindSpeed} ${t("w_kmh")}` : "--"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="st_position3">
                    <div className="windValueItem">
                      <div className="m_wind1">
                        <img
                          style={{
                            transform: `rotate(${STDirections(stData[0]?.sectional[3]?.avgWindDirection)}deg)`,
                          }}
                          src={getWindCorlor(stData[0]?.sectional[3]?.avgWindSpeed)}
                        />
                        <div className="windValue">
                          <p className="m_bold700_font m_normal_font">{stData[0]?.sectional[3]?.avgWindDirection ? t(`w_${stData[0]?.sectional[3]?.avgWindDirection}`) : "--"}</p>
                          <p className="m_bold500_font m_normal_font">{stData[0]?.sectional[3]?.avgWindSpeed ? `${stData[0]?.sectional[3]?.avgWindSpeed} ${t("w_kmh")}` : "--"}</p>
                        </div>
                      </div>
                      <div className="m_wind2">
                        <img src={`${assetPrefix}/windImg/windIcon.svg`} />
                        <p className="m_bold500_font m_normal_font">{stData[0]?.sectional[3]?.gustWindSpeed ? `${stData[0]?.sectional[3]?.gustWindSpeed} ${t("w_kmh")}` : "--"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="st_position4">
                    <div className="windValueItem">
                      <div className="m_wind1">
                        <img
                          style={{
                            transform: `rotate(${STDirections(stData[0]?.sectional[2]?.avgWindDirection)}deg)`,
                          }}
                          src={getWindCorlor(stData[0]?.sectional[2]?.avgWindSpeed)}
                        />
                        <div className="windValue">
                          <p className="m_bold700_font m_normal_font">{stData[0]?.sectional[2]?.avgWindDirection ? t(`w_${stData[0]?.sectional[2]?.avgWindDirection}`) : "--"}</p>
                          <p className="m_bold500_font m_normal_font">{stData[0]?.sectional[2]?.avgWindSpeed ? `${stData[0]?.sectional[2]?.avgWindSpeed} ${t("w_kmh")}` : "--"}</p>
                        </div>
                      </div>
                      <div className="m_wind2">
                        <img src={`${assetPrefix}/windImg/windIcon.svg`} />
                        <p className="m_bold500_font m_normal_font">{stData[0]?.sectional[2]?.gustWindSpeed ? `${stData[0]?.sectional[2]?.gustWindSpeed} ${t("w_kmh")}` : "--"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={currentTab === "HV" ? "m_track_show" : "m_track_hidden"}>
              <img className="compass_hv" src={`${assetPrefix}/windImg/Compass-normal.svg`} />
              <div className="m_windTrackMapWrapper">
                <div
                  style={{
                    background: isDwon375
                      ? `url("${assetPrefix}/windImg/HV Mobile_track320px.svg") no-repeat center center`
                      : `url("${assetPrefix}/windImg/track_hv_m.svg") no-repeat center center`,
                  }}
                  className="track_hv"
                >
                  <div className="hv_position1">
                    <div className="windValueItem">
                      <div className="m_wind1">
                        <img
                          style={{
                            transform: `rotate(${HVDirections(hvData[0]?.sectional[0]?.avgWindDirection)}deg)`,
                          }}
                          src={getWindCorlor(hvData[0]?.sectional[0]?.avgWindSpeed)}
                        />
                        <div className="windValue">
                          <p className="m_bold700_font m_normal_font">{hvData[0]?.sectional[0]?.avgWindDirection ? t(`w_${hvData[0]?.sectional[0]?.avgWindDirection}`) : "--"}</p>
                          <p className="m_bold500_font m_normal_font">{hvData[0]?.sectional[0]?.avgWindSpeed ? `${hvData[0]?.sectional[0]?.avgWindSpeed} ${t("w_kmh")}` : "--"}</p>
                        </div>
                      </div>
                      <div className="m_wind2">
                        <img src={`${assetPrefix}/windImg/windIcon.svg`} />
                        <p className="m_bold500_font m_normal_font">{hvData[0]?.sectional[0]?.gustWindSpeed ? `${hvData[0]?.sectional[0]?.gustWindSpeed} ${t("w_kmh")}` : "--"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="hv_position2">
                    <div className="windValueItem">
                      <div className="m_wind1">
                        <img
                          style={{
                            transform: `rotate(${HVDirections(hvData[0]?.sectional[1]?.avgWindDirection)}deg)`,
                          }}
                          src={getWindCorlor(hvData[0]?.sectional[1]?.avgWindSpeed)}
                        />
                        <div className="windValue">
                          <p className="m_bold700_font m_normal_font">{hvData[0]?.sectional[1]?.avgWindDirection ? t(`w_${hvData[0]?.sectional[1]?.avgWindDirection}`) : "--"}</p>
                          <p className="m_bold500_font m_normal_font">{hvData[0]?.sectional[1]?.avgWindSpeed ? `${hvData[0]?.sectional[1]?.avgWindSpeed} ${t("w_kmh")}` : "--"}</p>
                        </div>
                      </div>
                      <div className="m_wind2">
                        <img src={`${assetPrefix}/windImg/windIcon.svg`} />
                        <p className="m_bold500_font m_normal_font">{hvData[0]?.sectional[1]?.gustWindSpeed ? `${hvData[0]?.sectional[1]?.gustWindSpeed} ${t("w_kmh")}` : "--"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="hv_position3">
                    <div className="windValueItem">
                      <div className="m_wind1">
                        <img
                          style={{
                            transform: `rotate(${HVDirections(hvData[0]?.sectional[3]?.avgWindDirection)}deg)`,
                          }}
                          src={getWindCorlor(hvData[0]?.sectional[3]?.avgWindSpeed)}
                        />
                        <div className="windValue">
                          <p className="m_bold700_font m_normal_font">{hvData[0]?.sectional[3]?.avgWindDirection ? t(`w_${hvData[0]?.sectional[3]?.avgWindDirection}`) : "--"}</p>
                          <p className="m_bold500_font m_normal_font">{hvData[0]?.sectional[3]?.avgWindSpeed ? `${hvData[0]?.sectional[3]?.avgWindSpeed} ${t("w_kmh")}` : "--"}</p>
                        </div>
                      </div>
                      <div className="m_wind2">
                        <img src={`${assetPrefix}/windImg/windIcon.svg`} />
                        <p className="m_bold500_font m_normal_font">{hvData[0]?.sectional[3]?.gustWindSpeed ? `${hvData[0]?.sectional[3]?.gustWindSpeed} ${t("w_kmh")}` : "--"}</p>
                      </div>
                    </div>
                  </div>
                  <div className="hv_position4">
                    <div className="windValueItem">
                      <div className="m_wind1">
                        <img
                          style={{
                            transform: `rotate(${HVDirections(hvData[0]?.sectional[2]?.avgWindDirection)}deg)`,
                          }}
                          src={getWindCorlor(hvData[0]?.sectional[2]?.avgWindSpeed)}
                        />
                        <div className="windValue">
                          <p className="m_bold700_font m_normal_font">{hvData[0]?.sectional[2]?.avgWindDirection ? t(`w_${hvData[0]?.sectional[2]?.avgWindDirection}`) : "--"}</p>
                          <p className="m_bold500_font m_normal_font">{hvData[0]?.sectional[2]?.avgWindSpeed ? `${hvData[0]?.sectional[2]?.avgWindSpeed} ${t("w_kmh")}` : "--"}</p>
                        </div>
                      </div>
                      <div className="m_wind2">
                        <img src={`${assetPrefix}/windImg/windIcon.svg`} />
                        <p className="m_bold500_font m_normal_font">{hvData[0]?.sectional[2]?.gustWindSpeed ? `${hvData[0]?.sectional[2]?.gustWindSpeed} ${t("w_kmh")}` : "--"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m_windGust">
              <div className="m_gustItem">
                <div style={{ backgroundColor: "rgba(27, 140, 71, 1)" }} className="m_circle" />
                <p className="m_normal_font">0-12 {t("w_kmh")}</p>
              </div>
              <div className="m_gustItem">
                <div style={{ backgroundColor: "rgba(84, 184, 250, 1)" }} className="m_circle" />
                <p className="m_normal_font">13-30 {t("w_kmh")}</p>
              </div>
              <div className="m_gustItem">
                <div style={{ backgroundColor: "rgba(38, 85, 204, 1)" }} className="m_circle" />
                <p className="m_normal_font">31-40 {t("w_kmh")}</p>
              </div>
              <div className="m_gustItem">
                <div style={{ backgroundColor: "rgba(255, 156, 0, 1)" }} className="m_circle" />
                <p className="m_normal_font">41-62 {t("w_kmh")}</p>
              </div>
              <div className="m_gustItem">
                <div style={{ backgroundColor: "rgba(205, 0, 1, 1)" }} className="m_circle" />
                <p className="m_normal_font">63+ {t("w_kmh")}</p>
              </div>
              <div className="m_gustItem2">
                <img src={`${assetPrefix}/windImg/windIcon.svg`} />
                <p className="m_normal_font">{t("w_windGust")}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="m_weatherContainer">
          <div className="m_weatherWrapper">
            {(!stGoingData && currentTab === "ST") || (!hvGoingData && currentTab === "HV") ? renderEmptyTurfAwt() : renderTurfAwt(currentTab === "ST" ? stGoingData : hvGoingData)}
            {renderBottom(currentTab === "ST" ? stData : hvData)}
          </div>

          <div className="m_bottomWrapper">
            <p className="m_normal_font">
              {t("w_localWeather")}{" "}
              <a href={`https://www.hko.gov.hk/${langCode === "en-us" ? "en" : "tc"}/wxinfo/currwx/flw.htm`} className="m_link_font">
                {`https://www.hko.gov.hk/${langCode === "en-us" ? "en" : "tc"}/wxinfo/currwx/flw.htm`}
              </a>
            </p>
            <p className="m_normal_font">
              {t("w_9dayWeather")}{" "}
              <a href={`https://www.hko.gov.hk/${langCode === "en-us" ? "en" : "tc"}/wxinfo/currwx/fnd.htm`} className="m_link_font">
                {`https://www.hko.gov.hk/${langCode === "en-us" ? "en" : "tc"}/wxinfo/currwx/fnd.htm`}
              </a>
            </p>
            <div style={{ marginTop: "12px" }}>
              <p className="m_normal_font">{t("w_remark")}</p>
              <p className="m_normal_font">{t("w_weatherInfo")}</p>
            </div>
          </div>
        </div>
      </div>
      {onlyData === "true" ? null : <Footer />}
    </>
  );
};
export default HomePageM;
